import {
  DEFAULT_STOREFRONT_APPEARANCE,
  type StorefrontAppearance,
} from "@/domain/storefront-appearance";
import { atom } from "jotai";

export const storefrontAppearanceAtom = atom<StorefrontAppearance>(
  DEFAULT_STOREFRONT_APPEARANCE,
);

export const storefrontAppearanceReadyAtom = atom(false);
